import { render, staticRenderFns } from "./TransactionsSellersPaymentsList.vue?vue&type=template&id=fdf1169e&"
import script from "./TransactionsSellersPaymentsList.vue?vue&type=script&lang=js&"
export * from "./TransactionsSellersPaymentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports